<template>
  <div class="normalContent" v-if="helmetInfo.heartRate || helmetInfo.bloodOxygen">
    <div class="inforMain">
      <div class="deviceInfo">
        <div class="func_block">
          <!-- 心率 -->
          <div class="iconBlock" :class="[isDefaultTheme ? 'icon1' : 'icon1_m']"></div>
          <div class="iconInfo">
            <span class="description"
              >{{ $t('heartRate') }}：
              <span class="description_value">
                {{ helmetInfo.heartRate ? helmetInfo.heartRate + $t('heartRateUnit') : '-' }}</span
              >
            </span>
            <div id="heartChart" :style="{ width: '190px', height: '120px' }"></div>
            <span class="heart-data heart-time">{{ helmetInfo.heartRateTime }}</span>
          </div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <!-- 血氧 -->
        <div class="func_block">
          <div class="iconBlock" :class="[isDefaultTheme ? 'icon2' : 'icon2_m']"></div>
          <div class="iconInfo">
            <span class="description"
              >{{ $t('BloodOxygen') }}：<span class="description_value">{{
                helmetInfo.bloodOxygen ? Number(helmetInfo.bloodOxygen).toFixed(1) + '%' : '-'
              }}</span></span
            >
            <!-- echart 容器 -->
            <div id="bloodChart" :style="{ width: '190px', height: '113px' }"></div>
            <span class="heart-data temp-time">{{ helmetInfo.bloodOxygenTime }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { healthRecord } from '@/api/monitor'
import { HeartChartOption, TempChartOption } from '@/assets/echartOption'
import { mapGetters } from 'vuex'
export default {
  props: {
    helmetdata: {
      type: Array / Object,
    },
  },
  data() {
    return {
      deviceName: '',
      helmetInfo: {
        bodyTemperature: '',
        bloodOxygen: '',
        heartRate: '',
        signLever: '',
        signNum: '',
        freeBattery: '',
        altitude: '',
        heartRateTime: '',
        bloodOxygenTime: '',
      },
      jlsHelmet: {},
    }
  },
  watch: {
    helmetdata: {
      immediate: true,
      handler(val) {
        if (val.deviceName) {
          this.searchPollInfo(val.specType, val)
          this.jlsHelmet = val
        }
      },
    },
  },
  methods: {
    // 获取心率体征等信息
    searchPollInfo(specType, item) {
      if (item) {
        this.deviceName = item.deviceName
      }
      this.healthRecord()
    },
    // 获取控制面板数据
    async healthRecord() {
      let param = {
        helmetId: this.deviceName,
        pageNum: 1,
        pageSize: 100,
      }
      healthRecord(param).then(res => {
        // 弹窗面板开关
        if (res.state === 0) {
          let healthStatusPage = res.value
          if (healthStatusPage) {
            this.drawHeartChart(healthStatusPage)
            this.drawbloodOxygenChart(healthStatusPage)
          } else {
            this.drawHeartChart()
            this.drawbloodOxygenChart()
          }
        }
      })
    },
    // 心率图表
    drawHeartChart(data) {
      let timeArr = []
      let xlength = ''
      this.helmetInfo.heartRate = ''
      let dataArr = []
      let heartRateStart = ''
      let heartRateEnd = ''
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          if (item.heartRate && item.heartRate !== 0) {
            dataArr.push(item.heartRate)
            let timestamp = item.logTimestamp

            let stamp = timestamp.split(' ')[1].slice(0, 5)
            timeArr.push(stamp)
            if (i === 0) {
              heartRateStart = timestamp.split(' ')[0]
            }
            if (i === data.length - 1) {
              heartRateEnd = timestamp.split(' ')[0]
            }
          }
        }
        this.helmetInfo.heartRate = dataArr[0]
        timeArr.reverse()
        dataArr.reverse()
        xlength = parseInt(timeArr.length / 4 + 1)
        if (heartRateStart === heartRateEnd) {
          this.helmetInfo.heartRateTime = heartRateStart
        } else {
          this.helmetInfo.heartRateTime = heartRateStart + '~' + heartRateEnd
        }
      }
      try {
        this.$refs.infoWindow.observer.disconnect()
      } catch {}
      setTimeout(() => {
        let heartChartId = document.getElementById('heartChart')
        if (heartChartId) {
          var myChart = this.$echarts.init(heartChartId)
          // 绘制图表
          myChart.setOption(HeartChartOption(timeArr, xlength, dataArr))
        }
      }, 1000)
    },
    // 血氧图表
    drawbloodOxygenChart(data) {
      let dataArr = []
      let timeArr = []
      let xlength = ''
      let tempArr = []
      let bloodOxygenStart = ''
      let bloodOxygenEnd = ''
      this.helmetInfo.bloodOxygen = ''
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let item = data[i]
          if (item.bloodOxygen && item.bloodOxygen !== 0) {
            // 显示血氧
            dataArr.push(item.bloodOxygen)
            let timestamp = item.logTimestamp
            let stamp = timestamp.split(' ')[1].slice(0, 5)
            timeArr.push(stamp)
            if (i === 0) {
              bloodOxygenStart = timestamp.split(' ')[0]
            }
            if (i === data.length - 1) {
              bloodOxygenEnd = timestamp.split(' ')[0]
            }
          }
        }
        this.helmetInfo.bloodOxygen = dataArr[0]
        timeArr.reverse()
        dataArr.reverse()
        xlength = parseInt(timeArr.length / 3 + 1)
        if (bloodOxygenStart === bloodOxygenEnd) {
          this.helmetInfo.bloodOxygenTime = bloodOxygenStart
        } else {
          this.helmetInfo.bloodOxygenTime = bloodOxygenStart + '~' + bloodOxygenEnd
        }
      }
      setTimeout(() => {
        let bloodChartId = document.getElementById('bloodChart')
        if (bloodChartId) {
          var myChartblood = this.$echarts.init(bloodChartId)
          // 绘制图表
          myChartblood.setOption(TempChartOption(timeArr, xlength, dataArr))
        }
      }, 1000)
      // 绘制图表
    },
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.normalContent
  margin: 10px 0
  .inforMain
    color #222222
    .deviceInfo
      display flex
      justify-content space-around
      border-top 1px solid #eff1f4
      border-bottom 1px solid #eff1f4
      .func_block
        display flex
        margin-top 4px
        margin-bottom 4px
        .iconBlock
          width 14px
          height 14px
          margin-right 7px
          background-size 100%
        .icon1
          bg-image('~@/icon/rate.png')
        .icon1_m
          bg-image('~@/icon/rate_m.png')
        .icon2
          bg-image('~@/icon/temp.png')
        .icon2_m
          bg-image('~@/icon/temp_m.png')
        .icon3
          bg-image('~@/icon/blood.png')
        .icon3_m
          bg-image('~@/icon/blood_m.png')
        .iconInfo
          display flex
          flex-direction column
          position relative
          .description
            font-size 12px
            line-height 12px
            font-weight 500
            margin-bottom 7px
          .description_value
            font-size 12px
            font-weight bold
          #heartChart
            left -8px
            top -8px
            position relative
          #tempChart
            left -8px
            top -8px
            position relative
          .heart-data
            font-size 12px
            position absolute
            bottom -3%
            width 90%
            text-align center
</style>
